
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexaAs6F0uOO1PbNxqH8DD_45e04gSZQCarVD9TCXJYV94KEMeta } from "/opt/build/repo/pages/index.vue?macro=true";
import { default as _91slug_933DatxxqP7JhCXIhbiyS0mAPgHyk0opep793_M6qE2KUMeta } from "/opt/build/repo/pages/[slug].vue?macro=true";
import { default as contactUtUBN6u09MOBXpCX2V4MTnIvODrHK3on_Sjbujn1zJsMeta } from "/opt/build/repo/pages/contact.vue?macro=true";
import { default as indexv8NODvmbP1WWrc_XQwaShbHtGsKk_QXIgR2jW_k3SpAMeta } from "/opt/build/repo/pages/ppe-equipment/index.vue?macro=true";
import { default as _91slug_93FNLQj_45luU8piwAOILt6FZ_Or5lXnInOQuD0aVfwUuHYMeta } from "/opt/build/repo/pages/ppe-equipment/[slug].vue?macro=true";
import { default as component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta } from "/opt/build/repo/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s } from "/opt/build/repo/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/opt/build/repo/pages/index.vue")
  },
  {
    name: "slug",
    path: "/:slug()",
    component: () => import("/opt/build/repo/pages/[slug].vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/opt/build/repo/pages/contact.vue")
  },
  {
    name: "ppe-equipment",
    path: "/ppe-equipment",
    component: () => import("/opt/build/repo/pages/ppe-equipment/index.vue")
  },
  {
    name: "ppe-equipment-slug",
    path: "/ppe-equipment/:slug()",
    component: () => import("/opt/build/repo/pages/ppe-equipment/[slug].vue")
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/home",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  }
]